import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BibleReader from '@/components/BibleReader';

import { useSafeBack } from '@/utils/useSafeBack';
export default function BibleReaderPage({ user }) {
  const navigate = useNavigate();
  const goBackSafe = useSafeBack('/home');
  const location = useLocation();

  // Accept targetReference from navigation state (e.g., from Daily Reflection scripture popup)
  const targetReference = location.state?.targetReference || null;

  const handleDiscuss = (scriptureBlock, reference) => {
    navigate('/chat', {
      state: { discussScripture: scriptureBlock, scriptureRef: reference }
    });
  };

  return (
    // Fixed-height container so the BibleReader's internal ScrollArea
    // has a real bounding box — without this, on desktop the parent
    // grows with content and the inner ScrollArea Viewport collapses,
    // which is what blocks mouse-wheel scrolling inside the reader.
    <div
      className="w-full overflow-hidden flex flex-col"
      style={{
        background: 'var(--theme-background)',
        height: 'var(--app-height, 100dvh)',
      }}
      data-testid="bible-reader-page"
    >
      <BibleReader
        onClose={goBackSafe}
        onDiscuss={handleDiscuss}
        standalone={true}
        targetReference={targetReference}
        user={user}
      />
    </div>
  );
}
